webpackJsonp([72],{

/***/ 1194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformUserUIPermissions_vue__ = __webpack_require__(2906);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_405df0d7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformUserUIPermissions_vue__ = __webpack_require__(5175);
function injectStyle (ssrContext) {
  __webpack_require__(5173)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlatformUserUIPermissions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_405df0d7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlatformUserUIPermissions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditLogTable_vue__ = __webpack_require__(2907);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03aafac2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditLogTable_vue__ = __webpack_require__(5178);
function injectStyle (ssrContext) {
  __webpack_require__(5176)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03aafac2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditLogTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03aafac2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditLogTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 2428:
/***/ (function(module, exports) {

module.exports = [{"id":-1,"label":"全部权限","children":[{"id":-2,"label":"用户管理","children":[{"id":4,"label":"添加用户"},{"id":5,"label":"查看用户"},{"id":6,"label":"修改用户"},{"id":7,"label":"删除用户"},{"id":264,"label":"用户沟通记录"},{"id":185,"label":"用户账户查询"},{"id":118,"label":"标签管理"},{"id":110,"label":"修改标签"},{"id":111,"label":"添加标签"},{"id":112,"label":"删除标签"},{"id":124,"label":"零豆增加"},{"id":125,"label":"零豆减少"},{"id":79,"label":"零豆管理"},{"id":214,"label":"批量零豆操作"},{"id":262,"label":"自选职业管理"},{"id":263,"label":"用户职业信息审核"},{"id":126,"label":"赏金管理"},{"id":24,"label":"用户账户金额查询"},{"id":127,"label":"订单管理"},{"id":109,"label":"添加消息"},{"id":26,"label":"群发消息"},{"id":27,"label":"给特定用户发消息"},{"id":117,"label":"优惠卷管理"},{"id":113,"label":"优惠卷明细"},{"id":114,"label":"添加优惠卷"},{"id":115,"label":"修改优惠卷"},{"id":116,"label":"删除优惠卷"},{"id":119,"label":"用户事件管理"},{"id":120,"label":"用户事件修改"},{"id":121,"label":"用户事件添加"},{"id":122,"label":"用户事件删除"},{"id":123,"label":"用户事件明细"},{"id":205,"label":"红包管理"},{"id":215,"label":"批量用户"},{"id":218,"label":"批量标签(标签池)"},{"id":219,"label":"批量标签(注册)"},{"id":221,"label":"批量标签(用户)"},{"id":223,"label":"批量定向红包"},{"id":224,"label":"活动管理"},{"id":228,"label":"封号"},{"id":229,"label":"批量封号"},{"id":267,"label":"条件搜索添加标签"},{"id":269,"label":"注销用户列表"},{"id":20001,"label":"新用户定义配置"},{"id":20002,"label":"新手任务配置"},{"id":20003,"label":"用户关联关系"},{"id":20004,"label":"风险用户统计"},{"id":20005,"label":"用户沟通记录批量导出"},{"id":20006,"label":"违规预警"}]},{"id":-3,"label":"任务管理","children":[{"id":9,"label":"查看任务"},{"id":8,"label":"添加任务"},{"id":10,"label":"修改任务"},{"id":61,"label":"复制任务"},{"id":11,"label":"删除任务"},{"id":180,"label":"收回任务"},{"id":160,"label":"批量审核通过"},{"id":161,"label":"一键审核"},{"id":184,"label":"数据分析管理"},{"id":198,"label":"同步数据"},{"id":202,"label":"质量管控"},{"id":203,"label":"质量管控导出"},{"id":212,"label":"按批次通过"},{"id":213,"label":"按批次收回"},{"id":216,"label":"按批次审核"},{"id":237,"label":"任务提示"},{"id":222,"label":"管理员确认后修改答案"},{"id":238,"label":"批量任务"},{"id":239,"label":"任务审批"},{"id":245,"label":"群组控制"},{"id":249,"label":"米单配置"},{"id":250,"label":"查看工单赏金"},{"id":251,"label":"查看工单用户信息"},{"id":265,"label":"前置抓拍对比导出"},{"id":268,"label":"交换工单数据"},{"id":287,"label":"工单证据找回"},{"id":288,"label":"退单规范评价"},{"id":289,"label":"工单申诉管理"},{"id":40012,"label":"工单申诉审核"},{"id":282,"label":"任务地图看板"},{"id":40010,"label":"实习生额外访问任务管理"},{"id":40011,"label":"重置进行中"}]},{"id":-4,"label":"批量任务","children":[{"id":46,"label":"批量任务"},{"id":12,"label":"批量上传任务"},{"id":49,"label":"批量修改任务"},{"id":74,"label":"批量图片打包下载"},{"id":4001,"label":"批量激活任务"}]},{"id":-5,"label":"标准模版","children":[{"id":128,"label":"标准模版管理"},{"id":186,"label":"产品列表"},{"id":132,"label":"区域列表"},{"id":133,"label":"指引模板"},{"id":134,"label":"区域添加"},{"id":135,"label":"区域修改"},{"id":136,"label":"区域删除"},{"id":137,"label":"指引模板添加"},{"id":138,"label":"指引模板修改"},{"id":139,"label":"指引模板删除"},{"id":141,"label":"指引模板复制"},{"id":105,"label":"任务类型管理"},{"id":220,"label":"示例图下载"}]},{"id":-6,"label":"系列任务","children":[{"id":47,"label":"系列任务"},{"id":51,"label":"查看系列任务"},{"id":50,"label":"添加系列任务"},{"id":52,"label":"修改系列任务"},{"id":53,"label":"复制系列任务"},{"id":54,"label":"删除系列任务"}]},{"id":-7,"label":"任务模版","children":[{"id":55,"label":"任务模板"},{"id":57,"label":"查看任务模板"},{"id":56,"label":"添加任务模板"},{"id":58,"label":"修改任务模板"},{"id":59,"label":"复制任务模板"},{"id":60,"label":"删除任务模板"}]},{"id":-8,"label":"分步模版","children":[{"id":90,"label":"分步模版"},{"id":91,"label":"查看分步模板"},{"id":92,"label":"添加分步模板"},{"id":93,"label":"修改分步模板"},{"id":211,"label":"批量更新任务(模板)"},{"id":94,"label":"复制分步模板"},{"id":95,"label":"删除任务模板"},{"id":97,"label":"修改分布模板任务指引"}]},{"id":-9,"label":"任务相关","children":[{"id":13,"label":"批量下载任务"},{"id":14,"label":"批量发布任务"},{"id":44,"label":"发布搜索结果"},{"id":182,"label":"发布任务"},{"id":20,"label":"审核通过"},{"id":21,"label":"审核不通过"},{"id":45,"label":"任务批次统计"},{"id":104,"label":"众包任务复核"},{"id":204,"label":"一致率导出"}]},{"id":-29,"label":"审单管理","children":[{"id":85,"label":"审单系统配置"},{"id":86,"label":"待分配复核列表"},{"id":87,"label":"复核任务列表"},{"id":88,"label":"复核目标配置"}]},{"id":-30,"label":"审单考核管理","children":[{"id":43,"label":"项目出勤配置"},{"id":41,"label":"审单目标配置"},{"id":42,"label":"KeyIn异常工单反馈"}]},{"id":-31,"label":"工作管理","children":[{"id":147,"label":"工作台"},{"id":148,"label":"项目审单管理"},{"id":149,"label":"我的审单"}]},{"id":-10,"label":"卖场管理","children":[{"id":28,"label":"查看卖场统计"},{"id":23,"label":"查看卖场"},{"id":15,"label":"添加卖场"},{"id":189,"label":"卖场标签添加"},{"id":190,"label":"卖场标签修改"},{"id":201,"label":"卖场标签删除"},{"id":16,"label":"修改卖场"},{"id":17,"label":"删除卖场"},{"id":38,"label":"卖场标签管理"},{"id":48,"label":"卖场上传"},{"id":75,"label":"查看区域"},{"id":76,"label":"添加区域"},{"id":77,"label":"修改区域"},{"id":78,"label":"删除区域"},{"id":181,"label":"卖场显示"},{"id":187,"label":"批量导入查理宝平台"},{"id":188,"label":"批量移除查理宝平台"},{"id":183,"label":"批量更新经纬度"},{"id":199,"label":"完成任务人员列表"},{"id":208,"label":"批量更新任务"},{"id":10001,"label":"客服修改经纬度日志"}]},{"id":-11,"label":"财务管理","children":[{"id":18,"label":"生成提现报表"},{"id":19,"label":"提现批次查看"},{"id":22,"label":"提现记录查看"},{"id":170,"label":"不活跃用户"},{"id":232,"label":"批量回滚"},{"id":233,"label":"微信提现打款"},{"id":234,"label":"付款审批"},{"id":291,"label":"付款审批(新)"},{"id":292,"label":"支付中心(新)"}]},{"id":-27,"label":"财务中心设置","children":[{"id":271,"label":"审批起始值"},{"id":272,"label":"付款科目管理"},{"id":273,"label":"公司管理"},{"id":277,"label":"账户管理"},{"id":278,"label":"开票名称管理"},{"id":274,"label":"部门管理"},{"id":275,"label":"对公账户列表"},{"id":276,"label":"员工账户列表"},{"id":279,"label":"客户开票信息管理"},{"id":280,"label":"账期管理"},{"id":27001,"label":"财务邮件设置"},{"id":281,"label":"百旺自动开票配置管理"}]},{"id":-12,"label":"统计管理","children":[{"id":25,"label":"审单大屏配置"}]},{"id":-13,"label":"后台管理","children":[{"id":0,"label":"添加后台用户"},{"id":1,"label":"查看后台用户"},{"id":2,"label":"修改后台用户"},{"id":3,"label":"删除后台用户"},{"id":29,"label":"添加运营参数"},{"id":30,"label":"查看运营参数"},{"id":31,"label":"修改运营参数"},{"id":32,"label":"删除运营参数"},{"id":33,"label":"添加教育视频"},{"id":34,"label":"查看教育视频"},{"id":35,"label":"修改教育视频"},{"id":36,"label":"删除教育视频"},{"id":195,"label":"发布APK版本"},{"id":196,"label":"修改APK参数"},{"id":197,"label":"删除APK版本"},{"id":230,"label":"福利社管理"},{"id":252,"label":"所有批量任务列表"},{"id":253,"label":"APP浮窗管理"},{"id":13001,"label":"任务包及培训配置"}]},{"id":-14,"label":"后台客户管理","children":[{"id":62,"label":"查看客户"},{"id":63,"label":"添加客户"},{"id":64,"label":"修改客户"},{"id":65,"label":"删除客户"},{"id":142,"label":"客户充值"},{"id":193,"label":"项目成本列表"},{"id":207,"label":"查看客户任务"},{"id":14001,"label":"项目进度列表"},{"id":14002,"label":"数据清洗专员(仅能操作清洗返回节点)"},{"id":14003,"label":"成本确认-审核人"},{"id":235,"label":"对公账户列表"},{"id":236,"label":"员工账户列表"},{"id":240,"label":"开票管理"},{"id":241,"label":"回款管理"},{"id":242,"label":"回款管理(旧)"},{"id":243,"label":"付款管理"},{"id":244,"label":"付款退款"},{"id":246,"label":"付款管理(新)"},{"id":248,"label":"批量客户"}]},{"id":-15,"label":"客户平台管理","children":[{"id":66,"label":"查看成员"},{"id":67,"label":"添加成员"},{"id":68,"label":"修改成员"},{"id":194,"label":"复制成员"},{"id":69,"label":"删除成员"}]},{"id":-16,"label":"客户项目管理","children":[{"id":70,"label":"查看项目"},{"id":130,"label":"查看项目明细"},{"id":71,"label":"添加项目"},{"id":72,"label":"修改项目"},{"id":73,"label":"删除项目"},{"id":106,"label":"审核项目"},{"id":107,"label":"完成项目"},{"id":108,"label":"关闭项目"},{"id":129,"label":"预算调整"},{"id":131,"label":"查看项目预算明细"},{"id":200,"label":"下线管理"}]},{"id":-17,"label":"客户批次管理","children":[{"id":80,"label":"查看批次"},{"id":81,"label":"添加批次"},{"id":83,"label":"修改批次"},{"id":82,"label":"删除批次"},{"id":84,"label":"查看批次统计"},{"id":17001,"label":"批次标签管理"}]},{"id":-208,"label":"待办管理","children":[{"id":2081,"label":"项目审核"}]},{"id":-18,"label":"issue管理","children":[{"id":39,"label":"查看issue"},{"id":40,"label":"查看所有issue"},{"id":225,"label":"管理issue（客户组）"},{"id":226,"label":"管理issue（客服组）"}]},{"id":-19,"label":"产品管理","children":[{"id":96,"label":"产品管理"}]},{"id":-20,"label":"查理宝平台","children":[{"id":140,"label":"查理宝平台"},{"id":100,"label":"查看通道"},{"id":101,"label":"添加通道"},{"id":102,"label":"修改通道"},{"id":103,"label":"删除通道"},{"id":146,"label":"查理宝客户管理"},{"id":143,"label":"查理宝任务"},{"id":144,"label":"查理宝任务批次统计"},{"id":145,"label":"查理宝项目成本列表"}]},{"id":-21,"label":"网站管理","children":[{"id":206,"label":"网站管理"}]},{"id":-22,"label":"星火平台","children":[{"id":150,"label":"星火平台"},{"id":151,"label":"星火客户管理"},{"id":152,"label":"星火任务"},{"id":153,"label":"星火任务批次统计"},{"id":154,"label":"星火项目成本统计"}]},{"id":-23,"label":"标注平台","children":[{"id":209,"label":"标注平台"},{"id":210,"label":"标注客户管理"}]},{"id":-24,"label":"招聘管理","children":[{"id":227,"label":"招聘管理"}]},{"id":-25,"label":"teke管理","children":[{"id":231,"label":"Teke管理"}]},{"id":-26,"label":"智能外呼","children":[{"id":261,"label":"智能外呼"}]},{"id":-27,"label":"智能客服管理","children":[{"id":266,"label":"智能客服管理"}]},{"id":-28,"label":"职业信息管理","children":[{"id":283,"label":"职业信息公司"},{"id":284,"label":"职业信息行业"},{"id":285,"label":"职业信息工种"},{"id":286,"label":"职业信息批量任务"}]},{"id":-40,"label":"实习生管理","children":[{"id":40001,"label":"实习生列表(同时允许导出基础信息)"},{"id":40008,"label":"实习生批量任务"},{"id":40009,"label":"实习生月度出勤"},{"id":40014,"label":"考勤计划月度列表"},{"id":40013,"label":"审单绩效统计"},{"id":40002,"label":"编辑/查看实习生基础资料"},{"id":40003,"label":"编辑/查看实习生隐私信息"},{"id":40004,"label":"编辑/查看实习生资源控制"},{"id":40005,"label":"编辑/查看实习生分配用户资源"},{"id":40006,"label":"添加实习生账号"},{"id":40007,"label":"导出实习生全部信息"}]},{"id":-33,"label":"人事管理","children":[{"id":290,"label":"员工管理"}]},{"id":-34,"label":"考试培训管理","children":[{"id":34001,"label":"培训管理"},{"id":34002,"label":"零工教程管理"},{"id":34006,"label":"实习生教程管理"},{"id":34003,"label":"考试管理"},{"id":34007,"label":"实习生考试管理"},{"id":34004,"label":"题目管理"},{"id":34005,"label":"知识库管理"}]},{"id":-35,"label":"录音风险管理","children":[{"id":35002,"label":"录音风险配置"},{"id":35003,"label":"录音风险列表"},{"id":35001,"label":"项目统计"}]},{"id":-36,"label":"新宴席管理","children":[{"id":36001,"label":"新宴席管理"}]}]}]

/***/ }),

/***/ 2906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_platform_user_data_platform_user_ui_permissions_json__ = __webpack_require__(2428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_platform_user_data_platform_user_ui_permissions_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_platform_user_data_platform_user_ui_permissions_json__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PlatformUserUIPermissions',
  data: function data() {
    return {
      platformUserUIPermissions: _.cloneDeep(__WEBPACK_IMPORTED_MODULE_2__views_platform_user_data_platform_user_ui_permissions_json___default.a),
      filterText: '',
      checkedPermissions: [],
      roles: [],
      adminName: ''
    };
  },

  computed: {},
  watch: {
    filterText: _.debounce(function (val) {
      this.$refs.tree.filter(val);
    }, 250)
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getUiRolesIndex', 'getUiRoleDetail']), {
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getCheckedKeys: function getCheckedKeys() {
      return this.$refs.tree.getCheckedKeys().filter(function (v) {
        return v > 0;
      });
    },
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('findPermissions', id).then(function (_ref) {
        var data = _ref.data;

        _this.adminName = data.name;
        _this.checkedPermissions = data.permission;
        _this.roles = data.roles;

        _this.updateTreeByRoles(data.roles);
      });
    },
    getForm: function getForm() {
      return this.getCheckedKeys();
    },
    onSubmit: function onSubmit() {
      this.update(this.id);
    },
    update: function update(id) {
      var _this2 = this;

      request.common('updatePermissions', {
        route: id,
        data: {
          permission: this.getForm(),
          roles: this.roles
        }
      }).then(function (res) {
        _this2.$confirm(_this2.$route.name + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this2.$router.push({ path: '/platform-user/table/' });
        });
      });
    },
    onExpand: function onExpand() {
      var expanded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.$refs.tree.root.childNodes[0].childNodes.forEach(function (node) {
        node.expanded = expanded;
      });
    },
    updateTreeByRoles: function updateTreeByRoles(roleIds) {
      var _this3 = this;

      if (roleIds.length === 0) {
        return this.updateTree(this.checkedPermissions, []);
      }
      request.common('getUiRolePermissionsIndex', { role_ids: roleIds }).then(function (_ref2) {
        var data = _ref2.data;

        _this3.updateTree(_this3.checkedPermissions, data.permission);
      });
    },
    onSelectRole: function onSelectRole() {
      this.updateTreeByRoles(this.roles);
    },
    updateTree: function updateTree(userPermissions, rolePermissions) {
      var checkedKeys = rolePermissions.concat(userPermissions);

      this.$refs.tree.setCheckedKeys(checkedKeys);
      this.disableTree(rolePermissions.map(function (one) {
        return one * 1;
      }), this.platformUserUIPermissions);
    },
    disableTree: function disableTree(permissions, collection) {
      for (var i in collection) {
        if (collection.hasOwnProperty(i)) {
          collection[i].disabled = permissions.includes(collection[i].id);
          if (collection[i].children && collection[i].children.length > 0) {
            this.disableTree(permissions, collection[i].children);
          }
        }
      }
    }
  })
});

/***/ }),

/***/ 2907:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_mixins_table__ = __webpack_require__(1346);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__core_mixins_table__["b" /* default */]],
  data: function data() {
    return {
      // 表格数据
      table: []
    };
  },
  created: function created() {},

  methods: {
    getTableData: function getTableData(params) {
      return request.page('AuditLogTableApi', params);
    }
  }
});

/***/ }),

/***/ 5173:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5174);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7a43133a", content, true, {});

/***/ }),

/***/ 5174:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".platform-user-ui-permissions .el-tree-node__label{margin-left:5px}", "", {"version":3,"sources":["/workspace/src/views/platform-user/pages/PlatformUserUIPermissions.vue"],"names":[],"mappings":"AACA,mDAAmD,eAAe,CACjE","file":"PlatformUserUIPermissions.vue","sourcesContent":["\n.platform-user-ui-permissions .el-tree-node__label{margin-left:5px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"platform-user-ui-permissions"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/platform-user/table"}},[_vm._v("平台用户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.name))])],1)],1),_vm._v(" "),_c('el-card',{attrs:{"shadow":"always"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("修改"),_c('b',[_vm._v(_vm._s(_vm.adminName))]),_vm._v("账户的权限")])]),_vm._v(" "),_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-form-item',{staticStyle:{"max-width":"460px"},attrs:{"prop":"roles","label":"角色"}},[_c('remote-select',{staticClass:"width-max",attrs:{"id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","placeholder":"请输入角色关键字","multiple":"","query-request":_vm.getUiRolesIndex,"find-request":_vm.getUiRoleDetail},on:{"change":_vm.onSelectRole,"findSuccess":_vm.onSelectRole},model:{value:(_vm.roles),callback:function ($$v) {_vm.roles=$$v},expression:"roles"}})],1),_vm._v(" "),_c('el-form-item',[_c('div',{staticStyle:{"margin-bottom":"15px"}},[_c('el-input',{staticStyle:{"width":"300px","margin-right":"10px"},attrs:{"placeholder":"输入关键字进行过滤"},model:{value:(_vm.filterText),callback:function ($$v) {_vm.filterText=$$v},expression:"filterText"}},[_c('i',{staticClass:"el-input__icon el-icon-search",attrs:{"slot":"prefix"},slot:"prefix"})]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.onExpand(true)}}},[_vm._v("展 开\n          ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.onExpand(false)}}},[_vm._v("收 起\n          ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("保 存\n          ")])],1),_vm._v(" "),_c('el-tree',{ref:"tree",attrs:{"data":_vm.platformUserUIPermissions,"default-expanded-keys":[-1],"default-checked-keys":_vm.checkedPermissions,"show-checkbox":"","node-key":"id","expand-on-click-node":false,"filter-node-method":_vm.filterNode}})],1)],1)],1),_vm._v(" "),_c('el-backtop',{attrs:{"target":"main"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5176:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5177);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("36c4ecc4", content, true, {});

/***/ }),

/***/ 5177:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".custom-form .re-el-form__flex[data-v-03aafac2]{margin:0}.custom-form .el-select[data-v-03aafac2]{width:100%}.custom-form .form-panel[data-v-03aafac2]{width:100%;margin:15px 0 0}.custom-form .form-slider[data-v-03aafac2]{padding:0 0 0 10px}.popover-table[data-v-03aafac2]{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;background-color:rgba(0,0,0,.5);z-index:999}.popover-table .popover-table-body[data-v-03aafac2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;max-height:80%;min-height:200px;max-width:80%;margin:auto;background-color:#fff;border-radius:5px;overflow:hidden}.popover-table .popover-table-body>div[data-v-03aafac2]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:15px}.popover-table .popover-table-body .popover-table-header[data-v-03aafac2]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:900;color:#666;border-bottom:1px dashed #aaa}.popover-table .popover-table-body .popover-table-content[data-v-03aafac2]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto}", "", {"version":3,"sources":["/workspace/src/views/platform-user/style/PlatformUser.scss"],"names":[],"mappings":"AACA,gDAAgD,QAAQ,CACvD,AACD,yCAAyC,UAAU,CAClD,AACD,0CAA0C,WAAW,eAAe,CACnE,AACD,2CAA2C,kBAAkB,CAC5D,AACD,gCAAgC,eAAe,MAAM,SAAS,OAAO,QAAQ,SAAS,gCAAiC,WAAW,CACjI,AACD,oDAAoD,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,4BAA4B,wBAAwB,uBAAuB,oBAAoB,2BAA2B,eAAe,iBAAiB,cAAc,YAAY,sBAAsB,kBAAkB,eAAe,CAC5Y,AACD,wDAAwD,WAAW,8BAA8B,sBAAsB,YAAY,CAClI,AACD,0EAA0E,mBAAmB,oBAAoB,YAAY,oBAAoB,cAAc,eAAe,gBAAgB,WAAW,6BAA6B,CACrO,AACD,2EAA2E,mBAAmB,oBAAoB,YAAY,oBAAoB,cAAc,aAAa,CAC5K","file":"PlatformUser.scss","sourcesContent":["\n.custom-form .re-el-form__flex[data-v-03aafac2]{margin:0\n}\n.custom-form .el-select[data-v-03aafac2]{width:100%\n}\n.custom-form .form-panel[data-v-03aafac2]{width:100%;margin:15px 0 0\n}\n.custom-form .form-slider[data-v-03aafac2]{padding:0 0 0 10px\n}\n.popover-table[data-v-03aafac2]{position:fixed;top:0;bottom:0;left:0;right:0;margin:0;background-color:rgba(0,0,0,0.5);z-index:999\n}\n.popover-table .popover-table-body[data-v-03aafac2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;max-height:80%;min-height:200px;max-width:80%;margin:auto;background-color:#FFF;border-radius:5px;overflow:hidden\n}\n.popover-table .popover-table-body>div[data-v-03aafac2]{width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;padding:15px\n}\n.popover-table .popover-table-body .popover-table-header[data-v-03aafac2]{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;font-size:16px;font-weight:900;color:#666;border-bottom:1px dashed #AAA\n}\n.popover-table .popover-table-body .popover-table-content[data-v-03aafac2]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:auto\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.name),expression:"$route.name"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.name))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.name))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-table',{ref:"multipleTable",attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userid","label":"管理员ID"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"username","label":"管理员"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"opname","label":"管理员行为"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"时间"}})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/PlatformUserUIPermissions.3219f1c7620eebd149b8.js